import axios from "axios";
import useSWR from "swr";
import CONSTANT from "../constants/constant";

const fetcher = async (url) => await axios.get(url);

const SWRCatcher = (param) => {
  return useSWR(param ? `${CONSTANT.URL}/${param}` : null, fetcher);
};

const SWRCatcherWithInterval = (param) => {
  return useSWR(param ? `${CONSTANT.URL}/${param}` : null, fetcher, {
    refreshInterval: 10000,
  });
};

export const searchVideo = (param) => {
  return { ...SWRCatcher(param ? `search?q=${param}` : null) };
};

export const getVideoDetail = (param) => {
  return { ...SWRCatcher(param ? `videos/${param}` : null) };
};

export const createNewPlaylistByName = async (playlistName) => {
  return await axios.post(`${CONSTANT.URL}/playlists`, {
    name: playlistName,
  });
};

export const addVideoToPlaylist = async (playlistId, video) => {
  return await axios.post(`${CONSTANT.URL}/playlists/${playlistId}/videos`, {
    ...video,
  });
};

export const updateVideoPlaylist = async (playlistId, name, videos) => {
  return await axios.put(`${CONSTANT.URL}/playlists/${playlistId}`, {
    name: name,
    videos: videos,
  });
};

export const fetchPlaylistDetails = (playlistId) => {
  return {
    ...SWRCatcherWithInterval(playlistId ? `playlists/${playlistId}` : null),
  };
};
